import React from 'react';
import {
    Box,
    CircularProgress
} from '@material-ui/core';

// Mobile WebView SSO is handled via the main Login page (/).
// This route is kept for backwards compatibility.
export const Mobile = () => {
    return (
        <Box position='absolute' left='50%' top='50%'>
            <CircularProgress />
        </Box>
    );
};
